import { useEffect } from "react";
import Button from "../components/Lcomp/Button";
import Badge from "../components/Lcomp/Badge";
import SuccessStory from "../components/Lcomp/SuccessStory";
import Transplant from "../components/Lcomp/Transplant";
import { Link } from "react-router-dom";

import { FaHospitalUser, FaVial, FaUserFriends, FaMicroscope, FaProcedures, FaHeartbeat, FaFlask } from "react-icons/fa"; // Example icons

import AOS from "aos";
import "aos/dist/aos.css";

const servicesData = [
  { icon: <FaHospitalUser size={40} className="text-primary_red" />, label: "Bone Marrow Transplant" },
  { icon: <FaVial size={40} className="text-primary_red" />, label: "HLA Typing" },
  { icon: <FaUserFriends size={40} className="text-primary_red" />, label: "Counselling & Psychosocial Services" },
  { icon: <FaMicroscope size={40} className="text-primary_red" />, label: "Pre-Transplant Evaluation" },
  { icon: <FaProcedures size={40} className="text-primary_red" />, label: "Stem Cell Processing" },
  { icon: <FaHeartbeat size={40} className="text-primary_red" />, label: "Post-Transplant Clinic" },
  { icon: <FaFlask size={40} className="text-primary_red" />, label: "Chimerism" },
];

const Services = () => {
  useEffect(() => {
    AOS.init({ once: true });
  }, []);

  return (
    <>
      <section className="h-max flex flex-col lg:flex-row items-center justify-center pr-0 lg:pr-14 gap-10 mt-5 ">
        <div
          data-aos="fade-right"
          data-aos-duration="500"
          className="mt-24 w-full lg:w-1/2 h-full p-0 lg:p-10 pl-0"
        >
          <img
            src="./assets/bmt/service.jpg"
            alt=""
            className="object-cover w-full rounded-lg shadow-lg"
          />
        </div>
        <div
          data-aos="fade-left"
          data-aos-duration="1000"
          className="w-full lg:w-1/2 flex flex-col justify-center px-[24px] md:px-16 lg:px-0"
        >
          <h2 className="w-full text-[34px] lg:text-[44px] leading-[1.2] capitalize font-[600] text-primary_red text-start">
            Our Multi-Disciplinary Services
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6 mt-8">
            {servicesData.map((service, index) => (
              <div
                key={index}
                className="flex flex-col items-center justify-center bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-all duration-300 text-center"
              >
                {service.icon}
                <p className="mt-4 text-[16px] md:text-[18px] font-medium text-gray-800">
                  {service.label}
                </p>
              </div>
            ))}
          </div>
          <Link
            to="https://docs.google.com/forms/d/e/1FAIpQLScJGyYtNBHX2yN0GqyeMchSxvdnSfZ7P-1Eo6AOQzD_0yaelA/viewform"
            className="md:flex md:items-center md:justify-center lg:block" target="_blank"
          >
            <Button
              classes="px-[48px] py-[12px] bg-primary_red font-Lexend font-bold rounded-[4px] text-[15px] hover:bg-primary_red/90 trans_animate tracking-wider block text-white mt-7 w-full md:w-[60%] lg:w-auto"
              text="Book Now"
            />
          </Link>
        </div>
      </section>
      <Badge />
      <Transplant />
      <SuccessStory />
    </>
  );
};

export default Services;
